import common from "../../utils/common"

export const user = {
  state: {
    userToken: '',
    roleId: '',
    userData: {},
    accessToken: '',
    currentRoute: '',
    roles: [],
    permissions: {},
    rolesWithUsers: [],
    rolesLoading: true
  },
  mutations: {
    'SET_USER_TOKEN' (state , token){
      state.userToken = token
    },
    'SET_USER_DATA' (state, userData) {
      state.userData = userData
    },
    'SET_ROLE_ID' (state, roleId) {
      state.roleId = roleId
    },
    'SET_ACCESS_TOKEN' (state, accessToken) {
      state.accessToken = accessToken
    },
    'SET_CURRENT_ROUTE' (state,currentRoute) {
      state.currentRoute = currentRoute
    },
    'SET_ROLES' (state, roles) {
      state.roles = roles
    },
    'SET_PERMISSIONS' (state, permissions) {
      state.permissions = permissions
    },
    'SET_ROLES_WITH_USERS' (state, rolesWithUsers) {
      state.rolesWithUsers = rolesWithUsers
    },
  },
  actions: {
    setUserToken({commit},token){
      commit('SET_USER_TOKEN',token)
    },
    setUserData({commit}, userData) {
      commit('SET_USER_DATA', userData)
    },
    setRoleId({commit}, roleId) {
      commit('SET_ROLE_ID',roleId)
    },
    setAccessToken({commit}, accessToken) {
      commit('SET_ACCESS_TOKEN',accessToken)
    },
    setCurrentRoute({commit}, currentRoute) {
      commit('SET_CURRENT_ROUTE',currentRoute)
    },
    fetchRoles({commit, state}, reload = false) {
      if(!state.roles.length || reload){
        state.rolesLoading = true
        this._vm.$http.get("/roles").then((response) => {
          commit('SET_ROLES', response.data)
          state.rolesLoading = false
        }).catch((error) => {
          if (error.response.status === 401) {
            common.logOut();
          }
        });
      }
    },
    fetchPermissions({commit, state}) {
      if(!Object.keys(state.permissions).length){
        this._vm.$http.get("/roles/permissions").then((response) => {
          const permissions = response.data.permissions
          const rolePermissions = {}
          permissions.forEach(permission => {
            rolePermissions[permission] = ['read', 'create', 'update', 'delete']
          });
          if(rolePermissions.users) {
            rolePermissions.users.push('updateOwn', 'updateStatus')
          }
          commit('SET_PERMISSIONS', rolePermissions)
        }).catch((error) => {
          console.log(error)
          if (error.response.status === 401) {
            common.logOut();
          }
        });
      }
    },
    fetchRolesWithUsers({commit, state}, reload = false) {
      if(!state.rolesWithUsers.length || reload){
        state.rolesLoading = true
        this._vm.$http.get("/roles/with-users").then((response) => {
          commit('SET_ROLES_WITH_USERS', response.data)
          state.rolesLoading = false
        }).catch((error) => {
          if (error.response.status === 401) {
            common.logOut();
          }
        });
      }
    }
  }
}